// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-5fe74fe0]{text-align:right}.machine-name[data-v-5fe74fe0]{font-weight:600}", ""]);
// Exports
module.exports = exports;
